export const Roles = {
	CreditAnalyst: 'CreditAnalyst',
	Investor: 'Lender',
	Borrower: 'Borrower',
	SuperAdmin: 'SuperAdmin',
	AccountManager: 'AccountManager',
};
